import * as ActionTypes from '../constants/ActionTypes'
import { getRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

export function errorForm(errors){
  return{
    type: ActionTypes.SET_ERROR_FORMS,
    errors: errors
  }
}

const getUser = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    dispatch(errorForm({'errors':{}}));
    getRequest(data, "profile").then(
      (response) => {
        dispatch(setData(response.data.user, 'user'));
        dispatch(setData(response.data.centro, 'centro'));
        dispatch(loading());
      },
      (err) => {
        dispatch(loading());
        if (err.response.status === 401) {
          dispatch(setData(true, 'error401'));
        }else{
          dispatch(setData(true, 'error'));
        }
      }
    );
  }
};

export default {
  getUser
}
